import React from "react";

import defaultIconProps from "@/constants/defaultIconProps";
import IconProps from "@/types/icons/IconProps";

const PieChartIcon: React.FC<IconProps> = props => {
  const { width, height, fontSize, color } = {
    ...defaultIconProps,
    ...props
  };
  return (
    <svg
      height={height}
      width={width}
      style={{ fontSize }}
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.44794 4.82249C8.33731 4.5056 9.14869 5.21903 9.14896 6.06178C9.14889 6.67038 8.74679 7.16521 8.22837 7.36059C5.75277 8.29337 3.98847 10.6818 3.98829 13.4745C3.9883 17.0783 6.92132 20.0117 10.5255 20.0117C13.3186 20.0117 15.7066 18.2472 16.6394 15.7716C16.8349 15.2534 17.3298 14.8512 17.9382 14.851C18.7811 14.851 19.4942 15.6627 19.1775 16.5521C17.9104 20.1078 14.5164 22.665 10.5255 22.665C5.45673 22.6649 1.335 18.5428 1.335 13.4745C1.33518 9.48409 3.89203 6.08964 7.44794 4.82249ZM5.73635 18.7475C5.7731 18.7809 5.81122 18.8127 5.84867 18.8454C5.80593 18.8081 5.76282 18.7713 5.72099 18.7331L5.73635 18.7475Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5085 1.33501C17.661 1.33501 22.6648 6.33909 22.665 12.4915C22.665 13.2242 22.0711 13.8181 21.3384 13.8181H11.5085C10.7758 13.8181 10.1819 13.2242 10.1819 12.4915V2.66165C10.1821 1.92914 10.776 1.33508 11.5085 1.33501ZM12.8352 11.1649H19.9061C19.335 7.53777 16.4625 4.66451 12.8352 4.09389V11.1649Z"
        fill={color}
      />
    </svg>
  );
};

export default PieChartIcon;